$(function() {
    moment.locale(bike.locale);

    function toggleFAQ(element) {
        element.classList.toggle('active');
    }

    function expandAllFAQ() {
        document.querySelectorAll('.faq-item').forEach(item => {
            item.classList.add('active');
        });
    }

    function collapseAllFAQ() {
        document.querySelectorAll('.faq-item').forEach(item => {
            item.classList.remove('active');
        });
    }

    const owlCarousel = () => {
        const homeOffersCarouselEl = $('.offers-section__carousel-cards')
        if ( homeOffersCarouselEl.length > 0 ) {
            homeOffersCarouselEl.owlCarousel({
                center: false,
                items: 1,
                loop: true,
                stagePadding: 0,
                margin: 16,
                smartSpeed: 1000,
                autoplay: true,
                nav: false,
                responsive:{
                    1200:{
                        margin: 16,
                        nav: true,
                        items: 2
                    }
                }
            });
            $('.offers-section__carousel-controls--next').click(function (e) {
                console.log('next clicked');
                e.preventDefault();
                homeOffersCarouselEl.trigger('next.owl.carousel');
            })
            $('.offers-section__carousel-controls--prev').click(function(e) {
                console.log('prev clicked');
                e.preventDefault();
                homeOffersCarouselEl.trigger('prev.owl.carousel');
            })
        }
    }

    const cookieConsent = (function () {

        const COOKIE_VALUE = 1;
        const COOKIE_LIFETIME = 7300;
        const COOKIE_NAME = 'consent_cookie';

        function consentWithCookies() {
            setCookie(COOKIE_NAME, COOKIE_VALUE, COOKIE_LIFETIME);
            location.reload();
        }

        function setCookie(name, value, expirationInDays) {
            const date = new Date();
            date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
            document.cookie = name + '=' + value
                + ';expires=' + date.toUTCString()
                + ';domain=' + window.location.hostname
                + ';path=/'
                + ';secure'
                + ';samesite=lax';
        }

        const buttons = document.getElementsByClassName('js-cookie-consent-agree');

        for (let i = 0; i < buttons.length; ++i) {
            buttons[i].addEventListener('click', consentWithCookies);
        }
    })();

    $(document).on('click', '.faq-item', function() {
        toggleFAQ(this);
    });

    $('#contract-success').modal('show');
    owlCarousel();

    //Manage SES field in contract update page
    $('.select_municipality_code').selectpicker();
    $('.select_nationality').selectpicker();
    // La del conductor adicional del check-in: la misma lista de países, que sin buscador es larga.
    $('.select_additional_driver_nationality').selectpicker();

    function toggleFieldsBasedOnCountry() {
        let country =  $("select[name^=nationality]").val();
        if (country === 'ESP') {
            $('select[name^=municipality_code]').attr('required', 'required');
            $('select[name^=municipality_name]').removeAttr('required');
            $('.ses_municipality_code').show();
            $('.ses_municipality_name').hide();
        } else {
            $('select[name^=municipality_name]').attr('required', 'required');
            $('select[name^=municipality_code]').removeAttr('required');
            $('.ses_municipality_code').hide();
            $('.ses_municipality_name').show();
        }
    }

    $(document).on("change", "select[name^=nationality]", function () {
        toggleFieldsBasedOnCountry();
    });
    toggleFieldsBasedOnCountry();
});



